<template>
  <div>
    <div slot="title">
      <h2 class="label-black">Reporte de Resultados por Nivel</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        
        <div class="row">
          
          <div class="col-9">
            

            <div class="row">
              <div class="col-4">
                <select class="form-control" v-model="tipoNivel" @change="cambiarValores">
                  <option value="1">Auxiliares</option>
                  <option value="2">Mandos Medios</option>
                  <option value="3">Directivos</option>
                </select>
              </div>
            </div>
                <div class="row" style="margin-top:10px;">
                  
                  <div class="col-12">
                    <ul class="nav nav-tabs" id="tabResultados1" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="Poligono-tab" data-toggle="tab" href="#Poligono" role="tab" aria-controls="Poligono" aria-selected="true">Poligono</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="Barras-tab" data-toggle="tab" href="#Barras" role="tab" aria-controls="Barras" aria-selected="false">Barras</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Poligono" role="tabpanel" aria-labelledby="Poligono-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="Barras" role="tabpanel" aria-labelledby="Barras-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions2" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                </div>
              

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    data() {
      return this.datosIniciales()
    },
    components: {
      highcharts
    },
    methods: {
      datosIniciales() {
        return {//asigna los valores iniciales del data
          tipoNivel: 1,
          nombreEvaluado: "",//Almacena el nombre del evaluado
          estatus: "Desconocido",//Almacena el estatusde la evaluación
          seccion: "",//Almacena la sección del evaluado
          departamento: "",//Almacena el departamento del evaluado
          puesto: "",//Almacena el puesto del evaluado
          tipoPuesto: "",//Almacena el tipo de contrato del evaluado
          periodoEvaluacion: "",//Almacena el periodo de evaluación
          evaluadoresAsignados: 0,//Almacena la cantidad de evaluadores asignados
          evaluadoId: 0,//Guarda el id del evaluado
          asignadosIniciales: false,
          evaluadores: [],
          comentario: "",
          terminado: true,
          comentado: false,
          ValoresResultados: [[0,0,0,0,0],[0,0,0,0,0],[0,0,0,0,0]],
          ValoresPerfiles: [[0,0,0,0,0], [0,0,0,0,0], [0,0,0,0,0]],
          ValoresResultados2: [[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],
          ValoresPerfiles2: [[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]],
          chartOptions:{chart:{renderTo:'container',polar:true,type:'line',backgroundColor:'transparent'},title:{text:'Resultado de Evaluación',x:0,style:{color:"#000000"}},pane:{size:'90%'},xAxis:{categories:['IntraPersonal','Interpersonal','Desarrollo de tareas','Entorno','Gerencia'],tickmarkPlacement:'on',lineWidth:0,labels:{style:{color:"#000000"}}},yAxis:{tickInterval:1,gridLineInterpolation:'polygon',lineWidth:0,min:0,max:4,labels:{style:{color:"#000000"}}},tooltip:{shared:true},legend:{align:'right',verticalAlign:'top',y:80,layout:'vertical',itemStyle:{color:'#000000'}},exporting:{buttons:{contextButton:{symbolStroke:"white",theme:{fill:"transparent"}}}},series:[{name:'Perfil del Puesto',type:'line',dashStyle:'ShortDash',data:[3,3.4,2.5,3.1,3.5],pointPlacement:'on',color:'#FF11AA',},{name:'Resultado',type:'line',data:[3.5,3,3.2,2.3,4],pointPlacement:'on',color:'#000000'}]},
          //chartOptions2: { chart: { type: 'column', backgroundColor: 'transparent' }, title: { text: 'Resultado de Evaluación', style: { color: "#fff" } }, subtitle: { text: 'Competencias', style: { color: "#fff" } }, xAxis: { categories: ['Autocontrol y estabilidad emocional', 'Confianza y seguridad en sí mismo', 'Resistencia a la adversidad', 'Comunicación', 'Establecimiento de relaciones', 'Negociación', 'Trabajo en equipo', 'Iniciativa', 'Orientación a resultados', 'Capacidad de análisis', 'Toma de decisiones', 'Conocimiento de la institución', 'Orientación al usuario', 'Apertura', 'Identificación con la institución', 'Dirección', 'Liderazgo', 'Planificación y organización', 'Visión y Anticipación'], crosshair: true, labels: { style: { color: "#fff" } } }, yAxis: { min: 0, max: 4, title: { text: 'Puntaje', style: { color: "#fff" } }, labels: { style: { color: "#fff" } } }, tooltip: { headerFormat: '<span style="font-size:10px">{point.key}</span><table>', pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true }, legend: { itemStyle: { color: '#FFF' } }, plotOptions: { column: { pointPadding: .2, borderWidth: 0 } }, exporting: { buttons: { contextButton: { symbolStroke: "white", theme: { fill: "transparent" } } } }, series: [{ name: 'Perfil del Puesto', data: [3.2, 2.4, 2, 1.7, 3, 3.1, 3.3, 2.7, 2, 3.1, 3, 2, 1.5, 1.4, 1.8, 3, 3.5, 2] }, { name: 'Resultado', data: [3.6, 2.2, 3, 1.9, 3, 3.1, 3, 2.9, 2.5, 3.7, 3.2, 2.1, 1.5, 1.2, 1.7, 3.3, 3.5, 1.8], color: '#cfcdcc' }] }, 
          chartOptions2: { chart: { type: 'column', backgroundColor: 'transparent' }, title: { text: 'Resultado de Evaluación', style: { color: "#000000" } }, subtitle: { text: 'Competencias', style: { color: "#000000" } }, xAxis: { categories: ['Autocontrol y estabilidad emocional', 'Confianza y seguridad en sí mismo', 'Resistencia a la adversidad', 'Comunicación', 'Establecimiento de relaciones', 'Negociación', 'Trabajo en equipo', 'Iniciativa', 'Orientación a resultados', 'Capacidad de análisis', 'Toma de decisiones', 'Conocimiento de la institución', 'Visión y Anticipación', 'Orientación al usuario', 'Apertura', 'Identificación con la institución', 'Dirección', 'Liderazgo', 'Planificación y organización'], crosshair: true, labels: { style: { color: "#000000" } } }, yAxis: { min: 0, max: 4, title: { text: 'Puntaje', style: { color: "#000000" } }, labels: { style: { color: "#000000" } } }, tooltip: { headerFormat: '<span style="font-size:10px">{point.key}</span><table>', pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true }, legend: { itemStyle: { color: '#000000' } }, plotOptions: { column: { pointPadding: .2, borderWidth: 0 } }, exporting: { buttons: { contextButton: { symbolStroke: "white", theme: { fill: "transparent" } } } }, series: [{ name: 'Perfil del Puesto', data: [3.2, 2.4, 2, 1.7, 3, 3.1, 3.3, 2.7, 2, 3.1, 3, 2, 1.5, 1.4, 1.8, 3, 3.5, 2], color: '#F72828' }, { name: 'Resultado', data: [3.6, 2.2, 3, 1.9, 3, 3.1, 3, 2.9, 2.5, 3.7, 3.2, 2.1, 1.5, 1.2, 1.7, 3.3, 3.5, 1.8], color: '#09893D' }] },
          }
      },
      cambiarValores: function () {
        
        this.chartOptions.series[1].data = this.ValoresResultados[this.tipoNivel - 1]
        this.chartOptions.series[0].data = this.ValoresPerfiles[this.tipoNivel - 1]
        this.chartOptions2.series[1].data = this.ValoresResultados2[this.tipoNivel - 1]
        this.chartOptions2.series[0].data = this.ValoresPerfiles2[this.tipoNivel - 1]
        if (this.tipoNivel == 1) {
          this.chartOptions.xAxis.categories= ['IntraPersonal', 'Interpersonal', 'Desarrollo de tareas', 'Entorno']
        } else {
          this.chartOptions.xAxis.categories = ['IntraPersonal', 'Interpersonal', 'Desarrollo de tareas', 'Entorno', 'Gerencia'];
        }
        
      },
      cargarDatosEvaluaciones: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetResultadosNivel, peticion).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response.data);
            this.ValoresResultados2[0] = response.data.ResultadosCompetenciasAux
            this.ValoresResultados2[1] = response.data.ResultadosCompetenciasMedios
            this.ValoresResultados2[2] = response.data.ResultadosCompetenciasDirectivos
            this.ValoresPerfiles2[0] = response.data.PerfilCompetenciasAux
            this.ValoresPerfiles2[1] = response.data.PerfilCompetenciasMedios
            this.ValoresPerfiles2[2] = response.data.PerfilCompetenciasDirectivos
            this.ValoresResultados[0] = response.data.ResultadosCategoriasAux
            this.ValoresResultados[1] = response.data.ResultadosCategoriasMedios
            this.ValoresResultados[2] = response.data.ResultadosCategoriasDirectivos
            this.ValoresPerfiles[0] = response.data.PerfilCategoriasAux
            this.ValoresPerfiles[1] = response.data.PerfilCategoriasMedios
            this.ValoresPerfiles[2] = response.data.PerfilCategoriasDirectivos
            //Extrae los resultados de la petición pára insertarlos en la vista
            this.cambiarValores();
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            comun.SeEstaCargandoInformacion(false);
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }
    },
    computed: {

    }, mounted: function mounted() {//Carga la información de la evaluación y la lista de cuestionarios al principio
      this.cargarDatosEvaluaciones();
    }

  }

</script>

<style scoped>
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/ReporteResultadosNivel.vue